module.exports = __webpack_public_path__ + "media/images/ico-select-826f76b33bce64fb9b238301cf71ef604b66a3be05e3989727e1045bd7381d34.svg";